<div class="container position-relative">
    <img class="secondary-footer-img hide-mobile d-none d-lg-block img-fluid position-absolute bottom-0 left-0"
         src="assets/components/footer-secondary/footer-img.webp" width="600" alt="" />

    <div class="row secondary-footer-content d-flex align-items-center justify-content-center">
        <div class="col-12 col-lg-5 offset-lg-7">
            <ng-container *ngFor="let item of items">
                <div class="text-white"
                     [ngClass]="item?.alignment"
                     [style.padding-top.px]="item?.padding"
                     [style.padding-bottom.px]="item?.padding"
                     *ngIf="item?.type == 'HEADING'"
                     [innerHTML]="item?.content">
                </div>

                <div class="text-white">
                    <div class="d-block mx-auto font-size-16"
                         [ngClass]="item?.alignment"
                         [style.padding-top.px]="item?.padding"
                         [style.padding-bottom.px]="item?.padding"
                         *ngIf="item?.type == 'TEXTAREA'">
                        {{ item?.content }}
                    </div>
                </div>

                <div [ngClass]="item?.alignment"
                     [style.padding-top.px]="item?.padding"
                     [style.padding-bottom.px]="item?.padding"
                     *ngIf="item?.type == 'LINK'">
                    <a routerLink="{{ item?.content?.link }}">
                        <button type="button" class="btn btn-dark rounded-pill font-size-16 font-weight-bold">
                            {{ item?.content?.text }}
                        </button>
                    </a>
                </div>
            </ng-container>
        </div>
    </div>
</div>